/**
 * The 18+ switch on the pause screen.
 *
 * Ticking it says "I am an adult" and nothing else: it changes how the game
 * words things, never what the world contains or how it plays. Two rules it
 * has to keep:
 *
 *   - off is the default, and stays the default after a broken or missing
 *     setting, a fresh browser, or private mode. Nothing coarse is ever shown
 *     to somebody who did not ask for it;
 *   - it can be changed at any time. The overlay is one Esc away, so this is
 *     never a one-time trap answered by a child on somebody else's laptop.
 *
 * The choice lives in localStorage, next to the skin and the recipe book - a
 * per-browser convenience, deliberately not part of the world save, since it
 * describes the person holding the mouse rather than the game they are
 * playing.
 */

import { parseTone, type Tone } from "../core/text/tone.js";
import { OverlayToggle } from "./overlayToggle.js";

const STORAGE_KEY = "vyzhyvannia.tone";

export class ToneToggle {
  private readonly toggle: OverlayToggle<Tone>;

  /** @param onChange runs after every change, so open panels can re-word. */
  constructor(onChange: () => void) {
    this.toggle = new OverlayToggle<Tone>(
      document.getElementById("adult-toggle") as HTMLInputElement,
      document.getElementById("adult-row") as HTMLLabelElement,
      STORAGE_KEY,
      parseTone,
      (tone) => ({ stored: tone, checked: tone === "adult" }),
      (checked) => (checked ? "adult" : "family"),
      onChange,
    );
  }

  get tone(): Tone {
    return this.toggle.value;
  }

  /** Follow the chosen map, the same as the other two switches. */
  retarget(key: string, fallback?: string): void {
    this.toggle.retarget(key, fallback);
  }
}
